//信心管理相关接口
import request from '../utils/axios'

// 获取巡护人名（根据权限）
export function GetPatrolUserName() {
    return request({
      url: '/Patrol/GetPatrolUserName',
      method: 'get',
    })
}


// 获取任务列表
export function GetListFromPC(params) {
  return request({
    url: "/Patrol/GetListFromPC",
    method: 'post',
		data:params
  })
}


// 获取打卡点
export function GetPatrolRoute(params) {
  return request({
    url: "/Patrol/GetPatrolRoute",
    method: 'post',
		data:params
  })
}

// 根据ids获取打卡点
export function GetPatroRouteByIds(params) {
  return request({
    url: "/Patrol/GetPatroRouteByIds",
    method: 'post',
		data:params
  })
}

// 获取巡护点位信息根据巡护Ids(工作人员)
export function GetPatrolsContentByPatrolsIds(params) {
  return request({
    url: "/Patrol/GetPatrolsContentByPatrolsIds",
    method: 'post',
		data:params
  })
}

// 根据id获取打卡点详情
export function GetPatroRouteDetailsById(params) {
  return request({
    url: "/Patrol/GetPatroRouteDetailsById",
    method: 'post',
		data:params
  })
}

// 根据任务id获取打卡点列表
export function GetPatrolsContentLisById(id) {
  return request({
    url: `/Patrol/GetPatrolsContentLisById?id=${id}`,
    method: 'get',
  })
}


// 主题上报相关接口

// 添加主题
export function AddEscalation(params) {
  return request({
    url: "/Escalation/AddEscalation",
    method: 'post',
		data:params
  })
}

// 获取主题
export function GetThemeTitleFromPC() {
  return request({
    url: '/Escalation/GetThemeTitleFromPC',
    method: 'get',
  })
}

// 根据id获取主题详情
export function GetThemeDetailsPC(id) {
  return request({
    url: `/Escalation/GetThemeDetailsPC?id=${id}`,
    method: 'get',
  })
}

// 修改主题
export function UpdateEscalation(params) {
  return request({
    url: "/Escalation/UpdateEscalation",
    method: 'post',
		data:params
  })
}

// 修改主题
export function GetEscalationThemeListPC(params) {
  return request({
    url: "/Escalation/GetEscalationThemeListPC",
    method: 'post',
		data:params
  })
}


// 获取路线根据ids
export function GetGeoByIds(params) {
  return request({
    url: "/Escalation/GetGeoByIds",
    method: 'post',
		data:params
  })
}


// 获取上报表详情
export function GetDetailsByIds(id) {
  return request({
    url: `/Escalation/GetDetailsByIds?id=${id}`,
    method: 'get',
  })
}




// 事件管理相关接口

// 获取列表
export function GetEventList(params) {
  return request({
    url: "/Event/GetList",
    method: 'post',
		data:params
  })
}
// 获取列表
export function GetEventDetails(params) {
  return request({
    url: `/Event/GetDetails?id=${params.id}&type=${params.type}`,
    method: 'get'
  })
}

// 获取事件处理人名（根据权限）
export function GetEventUserName(params) {
  return request({
    url: "/Event/GetEventUserName",
    method: 'get'
  })
}

// 审核
export function Examine(params) {
  return request({
    url: "/Event/Examine",
    method: 'post',
		data:params
  })
}